import apiClient from './apiClient';
import { ENDPOINTS } from './apiConfig';

/**
 * ------------------------------------------------------------------
 * SERVICIO DE TIPOS DE DOCUMENTO (DOCUMENT TYPES)
 * ------------------------------------------------------------------
 * Maneja las operaciones de lectura para tipos de documento
 * Basado en la documentación:
 * GET    /api/documenttypes        -> Listar tipos de documento
 * GET    /api/documenttypes/{id}   -> Obtener tipo de documento por ID
 * ------------------------------------------------------------------
 */

/**
 * Normaliza los datos del tipo de documento desde la API
 * Asegura tipos de datos consistentes
 */
const normalizeDocumentTypeData = (apiData) => {
    if (!apiData) return null;

    return {
        idtipo: apiData.idtipo || '',
        descripcion: apiData.descripcion || '',
        // Campos adicionales útiles para el frontend
        id: apiData.idtipo || '',
        label: apiData.descripcion || '',
        value: apiData.idtipo || ''
    };
};

const documentTypesService = {
    /**
     * Obtener todos los tipos de documento
     * @returns {Promise<Array>} Lista de tipos de documento
     */
    getAll: async () => {
        try {
            const response = await apiClient.get(ENDPOINTS.DOCUMENT_TYPES);
            const data = response;

            // Normalizar cada tipo de documento
            return Array.isArray(data) ? data.map(normalizeDocumentTypeData) : [];
        } catch (error) {
            console.error('Error fetching document types:', error);
            throw error;
        }
    },

    /**
     * Obtener un tipo de documento por ID
     * @param {string} id - ID del tipo de documento
     * @returns {Promise<Object>} Datos del tipo de documento
     */
    getById: async (id) => {
        try {
            const response = await apiClient.get(ENDPOINTS.DOCUMENT_TYPE_BY_ID(id));
            const data = response.data || response;
            return normalizeDocumentTypeData(data);
        } catch (error) {
            console.error(`Error fetching document type ${id}:`, error);
            throw error;
        }
    },

    /**
     * Obtener tipos de documento formateados para usar en selects
     * @returns {Promise<Array>} Array de objetos {value, label}
     */
    getAsOptions: async () => {
        try {
            const documentTypes = await documentTypesService.getAll();

            return documentTypes.map(docType => ({
                value: docType.idtipo,
                label: docType.descripcion,
                id: docType.idtipo
            }));
        } catch (error) {
            console.error('Error formatting document types as options:', error);
            throw error;
        }
    }
};

export default documentTypesService;
